import { useEffect, useState } from 'react';

import { Flex } from '@theme-ui/components';
import { keyframes } from '@emotion/react';

import Logo from '../Logo/Logo';

export type OpeningScreenProps = {
  timeout?: number;
};

const fadeOut = keyframes({ '50%': { opacity: 1 }, '100%': { opacity: 0 } });

const OpeningScreen = ({ timeout = 3000 }: OpeningScreenProps) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setShow(false);
    }, timeout);
  }, [timeout]);

  if (!show) {
    return null;
  }

  return (
    <Flex
      aria-label="opening-screen"
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1000,
        backgroundColor: 'primary',
        width: '100vw',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        animation: `${fadeOut} 3s linear forwards`,
      }}
    >
      <Logo />
    </Flex>
  );
};

export default OpeningScreen;
